import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-sparkle, message, like, heart"} maskId="square-filled-radius-0-stroke-1-IconBubbleSparkle"><path fillRule="evenodd" clipRule="evenodd" d="M21 3V19H15.1953L11.9961 21.6514L8.83398 19H3V3H21ZM10.5986 9.59961L7.99902 10.5996V11.4004L10.5986 12.4004L11.5986 15H12.3984L13.3984 12.4004L15.999 11.4004V10.5996L13.3984 9.59961L12.3984 7H11.5986L10.5986 9.59961Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleSparkle;
